import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, SearchIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
import { track } from '../../utils/analytics';
export function ClassicHero() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const onCta = (e: React.MouseEvent) => {
    e.preventDefault();
    track('hero_cta_click', {
      variant: 'classic'
    });
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-14 lg:pt-20 pb-16 lg:pb-24 overflow-hidden bg-navy-50" data-id="element-704" data-mp="1wc4pg4vjwrn1">
      <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-705" data-mp="1igshuwwar6op">
        <div className="absolute -top-40 -right-40 w-[700px] h-[700px] rounded-full bg-primary-200/25 blur-3xl hidden sm:block" data-id="element-706" data-mp="1meq8m45pu0u7" />
        <div className="absolute top-1/2 -left-20 w-[500px] h-[500px] rounded-full bg-primary-300/15 blur-3xl hidden sm:block" data-id="element-707" data-mp="71x4de9dzb9q" />
        <div className="absolute bottom-0 right-1/3 w-[400px] h-[400px] rounded-full bg-cyan-200/20 blur-3xl hidden sm:block" data-id="element-708" data-mp="nhe782s85qcs" />
        <div className="absolute top-1/4 right-1/4 w-[300px] h-[300px] rounded-full bg-indigo-200/10 blur-3xl hidden lg:block" data-id="element-709" data-mp="ik4iyqgknkqj" />
        <div className="absolute inset-0 opacity-[0.025]" style={{
        backgroundImage: `linear-gradient(rgba(15,23,42,1) 1px, transparent 1px), linear-gradient(90deg, rgba(15,23,42,1) 1px, transparent 1px)`,
        backgroundSize: '60px 60px'
      }} data-id="element-710" data-mp="wghrha34obsv" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-711" data-mp="1g6lgnwt7w0ct">
        <div className="max-w-4xl" data-id="element-712" data-mp="1g5s4ggbhoina">
          <motion.span initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-primary-50 border border-primary-200 text-primary-700 text-xs font-semibold tracking-wide uppercase" data-id="element-713" data-mp="1b7qoi49d0zg1">
            <SearchIcon className="w-3.5 h-3.5" data-id="element-714" data-mp="hwbuuevzi796" />
            {c.hero.eyebrow}
          </motion.span>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.08
        }} className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight leading-[1.1]" data-id="element-715" data-mp="mudep218ialp">
            {c.hero.h1}
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.16
        }} className="mt-5 text-base sm:text-lg text-navy-500 leading-relaxed max-w-3xl" data-id="element-716" data-mp="15k34faq5466r">
            {c.hero.lead}
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.24
        }} className="mt-8" data-id="element-717" data-mp="3cbax3ugl6njn">
            <a href="#contact" onClick={onCta} className="group inline-flex w-full sm:w-auto items-center justify-center gap-2 px-8 py-4 text-base font-semibold text-white bg-gradient-to-r from-primary-600 to-primary-500 rounded-xl hover:from-primary-700 hover:to-primary-600 transition-colors shadow-lg shadow-primary-600/25" data-id="element-718" data-mp="38t53knq4okvt">
              {c.hero.cta}
              <ArrowRightIcon className="w-4 h-4 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-719" data-mp="3rqoha4nj6rok" />
            </a>
          </motion.div>
        </div>

        <motion.dl initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.32
      }} className="mt-12 lg:mt-14 grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4" data-id="element-720" data-mp="3iqjl6qnsffpp">
          {c.hero.facts.map(f => <div key={f.label} className="p-5 rounded-2xl bg-white border border-navy-200 shadow-sm" data-id="element-721" data-mp="22d2u86wm744c">
              <dt className="text-2xl sm:text-3xl font-extrabold text-navy-900" data-id="element-722" data-mp="3q8plfnye393p">
                {f.value}
              </dt>
              <dd className="mt-1 text-xs sm:text-sm text-navy-500" data-id="element-723" data-mp="3v2ajffzzg32w">
                {f.label}
              </dd>
            </div>)}
        </motion.dl>
      </div>
    </section>;
}